import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import {
  DeviceDTO,
  EPDeviceDTO,
  GateDTO,
} from '@/../client-generator/generated-clients/plants';
import { getDeviceIconFromType } from '../../../../../core/utils/EntrancePlant/entrance-plant.utils';

@Options({
  name: 'DeviceObjectGroup',
  props: {
    device: {
      type: Object as PropType<EPDeviceDTO>,
      required: true,
    },
    hideConfig: {
      type: Boolean,
      default: false,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
  },
})
export default class DeviceObjectGroup extends Vue {
  device!: EPDeviceDTO;
  gate!: GateDTO;
  hideConfig!: boolean;
  disableActions!: boolean;
  getDeviceIconFromType = getDeviceIconFromType;

  getDeviceName() {
    switch (this.device.type) {
      case 0:
        return this.$t('AppResourceEP.NewPeDevice');
      case 1:
        return this.$t('AppResourceEP.KeyPad');
      case 2:
        return this.$t('AppResourceEP.SmartReader');
      default:
        'UNKNOWN';
    }
  }

  goToConfigureDevice() {
    alert('TODO');
  }
}
